(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-product-recommendations"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-product-recommendations')) {
    class CartProductRecommendations extends HTMLElement {
      constructor() {
        super();
        this.onCartChange = this.render.bind(this);
        this.onPrevClick = this.goToPrevious.bind(this);
        this.onNextClick = this.goToNext.bind(this);
        this.onMouseEnter = this.pauseAutoplay.bind(this);
        this.onMouseLeave = this.resumeAutoplay.bind(this);
        this.onVisibilityChange = this.handleVisibilityChange.bind(this);
        this.activeIndex = 0;
        this.autoplayTimer = null;
      }

      connectedCallback() {
        this.config = this.getConfig();
        this.cards = Array.from(this.querySelectorAll('[data-recommendation-product]'));
        this.emptyMessage = this.querySelector('.cart-recommendations__empty');
        this.viewport = this.querySelector('[data-cart-recommendations-viewport]');
        this.track = this.querySelector('[data-cart-recommendations-track]');
        this.dots = this.querySelector('[data-cart-recommendations-dots]');
        this.controls = this.querySelector('.cart-recommendations__controls');
        this.prevButton = this.querySelector('[data-cart-recommendations-prev]');
        this.nextButton = this.querySelector('[data-cart-recommendations-next]');
        document.addEventListener('theme:cart:change', this.onCartChange);
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        this.viewport?.addEventListener('mouseenter', this.onMouseEnter);
        this.viewport?.addEventListener('mouseleave', this.onMouseLeave);
        this.prevButton?.addEventListener('click', this.onPrevClick);
        this.nextButton?.addEventListener('click', this.onNextClick);
        this.bindRecommendationButtons();
        this.render();
      }

      disconnectedCallback() {
        document.removeEventListener('theme:cart:change', this.onCartChange);
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        this.viewport?.removeEventListener('mouseenter', this.onMouseEnter);
        this.viewport?.removeEventListener('mouseleave', this.onMouseLeave);
        this.prevButton?.removeEventListener('click', this.onPrevClick);
        this.nextButton?.removeEventListener('click', this.onNextClick);
        this.unbindRecommendationButtons();
        this.stopAutoplay();
      }

      getConfig() {
        const configNode = this.querySelector('[data-cart-recommendations-config]');
        if (!configNode) return {hideInCart: false, rules: []};

        try {
          return JSON.parse(configNode.textContent);
        } catch (error) {
          console.error('Failed to parse cart recommendation config', error);
          return {hideInCart: false, rules: []};
        }
      }

      getCartItems() {
        const items = document.querySelectorAll('[data-items-holder] [data-item]');

        return Array.from(items).map((item) => {
          const collections = (item.dataset.itemProductCollections || '')
            .split(',')
            .map((value) => value.trim().toLowerCase())
            .filter(Boolean);

          return {
            productId: String(item.dataset.itemProductId || ''),
            productType: String(item.dataset.itemProductType || '').trim().toLowerCase(),
            collections,
          };
        });
      }

      hasAnyMatch(sourceValues, targetValues) {
        if (!sourceValues.length || !targetValues.length) return false;
        return sourceValues.some((value) => targetValues.includes(String(value).trim().toLowerCase()));
      }

      evaluateRule(rule, cartItems) {
        if (!rule || !rule.enabled) return false;

        const cartProductIds = cartItems.map((item) => item.productId);
        const cartProductTypes = cartItems.map((item) => item.productType).filter(Boolean);
        const cartCollections = cartItems.flatMap((item) => item.collections);

        const hideMatched =
          this.hasAnyMatch(rule.hideProducts || [], cartProductIds) ||
          this.hasAnyMatch(rule.hideProductTypes || [], cartProductTypes) ||
          this.hasAnyMatch(rule.hideCollections || [], cartCollections);

        if (hideMatched) return false;

        const groups = [];

        if ((rule.matchProducts || []).length) {
          groups.push(this.hasAnyMatch(rule.matchProducts, cartProductIds));
        }

        if ((rule.matchProductTypes || []).length) {
          groups.push(this.hasAnyMatch(rule.matchProductTypes, cartProductTypes));
        }

        if ((rule.matchCollections || []).length) {
          groups.push(this.hasAnyMatch(rule.matchCollections, cartCollections));
        }

        if (!groups.length) return false;

        if (String(rule.ruleApplication || 'any').toLowerCase() === 'all') {
          return groups.every(Boolean);
        }

        return groups.some(Boolean);
      }

      getVisibleCards() {
        return this.cards.filter((card) => !card.hidden);
      }

      buildDots(visibleCards) {
        if (!this.dots) return;

        this.dots.innerHTML = '';

        if (visibleCards.length <= 1 || this.config.layout !== 'carousel') {
          this.dots.hidden = true;
          return;
        }

        visibleCards.forEach((card, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'cart-recommendations__dot';
          dot.setAttribute('aria-label', `Go to recommendation ${index + 1}`);
          dot.addEventListener('click', () => {
            this.activeIndex = index;
            this.updateCarouselPosition();
          });
          this.dots.appendChild(dot);
        });

        this.dots.hidden = false;
        this.updateActiveDot();
      }

      updateActiveDot() {
        if (!this.dots || this.dots.hidden) return;

        const visibleCards = this.getVisibleCards();
        const dots = Array.from(this.dots.children);

        if (!visibleCards.length || !dots.length) return;

        dots.forEach((dot, index) => {
          dot.classList.toggle('is-active', index === this.activeIndex);
          dot.setAttribute('aria-current', index === this.activeIndex ? 'true' : 'false');
        });
      }

      updateArrowState() {
        if (!this.prevButton || !this.nextButton) return;

        const visibleCards = this.getVisibleCards();
        const hasMultiple = this.config.layout === 'carousel' && visibleCards.length > 1;

        if (this.controls) {
          this.controls.hidden = !hasMultiple;
        }

        this.prevButton.hidden = !hasMultiple;
        this.nextButton.hidden = !hasMultiple;

        if (!hasMultiple) return;

        this.prevButton.disabled = this.activeIndex <= 0;
        this.nextButton.disabled = this.activeIndex >= visibleCards.length - 1;
      }

      updateCarouselPosition() {
        if (!this.track) return;

        const visibleCards = this.getVisibleCards();

        if (!visibleCards.length) {
          this.track.style.transform = 'translateX(0)';
          return;
        }

        const maxIndex = visibleCards.length - 1;
        this.activeIndex = Math.max(0, Math.min(this.activeIndex, maxIndex));

        const activeCard = visibleCards[this.activeIndex];
        const offset = activeCard ? activeCard.offsetLeft : 0;

        this.track.style.transform = `translateX(-${offset}px)`;
        this.updateActiveDot();
        this.updateArrowState();
      }

      goToPrevious() {
        this.activeIndex -= 1;
        this.updateCarouselPosition();
        this.resumeAutoplay();
      }

      goToNext() {
        this.activeIndex += 1;
        this.updateCarouselPosition();
        this.resumeAutoplay();
      }

      stopAutoplay() {
        if (this.autoplayTimer) {
          window.clearInterval(this.autoplayTimer);
          this.autoplayTimer = null;
        }
      }

      startAutoplay() {
        this.stopAutoplay();

        if (!this.config?.autoplay || this.config.layout !== 'carousel') return;

        const visibleCards = this.getVisibleCards();
        if (visibleCards.length <= 1) return;

        const intervalMs = Math.max(Number(this.config.autoplaySeconds || 5), 1) * 1000;

        this.autoplayTimer = window.setInterval(() => {
          const currentVisibleCards = this.getVisibleCards();
          if (document.hidden || currentVisibleCards.length <= 1) return;

          const maxIndex = currentVisibleCards.length - 1;
          this.activeIndex = this.activeIndex >= maxIndex ? 0 : this.activeIndex + 1;
          this.updateCarouselPosition();
        }, intervalMs);
      }

      pauseAutoplay() {
        this.stopAutoplay();
      }

      resumeAutoplay() {
        this.startAutoplay();
      }

      handleVisibilityChange() {
        if (document.hidden) {
          this.pauseAutoplay();
        } else {
          this.resumeAutoplay();
        }
      }

      bindRecommendationButtons() {
        this.unbindRecommendationButtons();

        this.recommendationButtons = Array.from(this.querySelectorAll('[data-recommendation-add-to-cart]'));
        this.recommendationButtons.forEach((button) => {
          const handler = (event) => this.handleRecommendationClick(event, button);
          button.__recommendationAddHandler = handler;
          button.addEventListener('click', handler, true);
        });
      }

      unbindRecommendationButtons() {
        if (!this.recommendationButtons) return;

        this.recommendationButtons.forEach((button) => {
          if (button.__recommendationAddHandler) {
            button.removeEventListener('click', button.__recommendationAddHandler, true);
            delete button.__recommendationAddHandler;
          }
        });

        this.recommendationButtons = [];
      }

      handleRecommendationClick(event, button) {
        event.preventDefault();
        event.stopPropagation();

        const form = button.closest('form');
        const properties = {};
        const datasetVariantId = button.getAttribute('data-recommendation-variant-id');
        const datasetPropertyName = button.getAttribute('data-recommendation-property-name');
        const datasetPropertyValue = button.getAttribute('data-recommendation-property-value');
        let variantId = datasetVariantId;
        let quantityValue = 1;
        let formEntries = [];
        let formData = null;
        const quickAddHolder = button.closest('[data-quick-add-holder]');

        if (datasetPropertyName && datasetPropertyValue) {
          properties[datasetPropertyName] = datasetPropertyValue;
        }

        if (form) {
          formData = new FormData(form);
          formEntries = Array.from(formData.entries());
          const formVariantId = formData.get('id');
          const formQuantityValue = parseInt(formData.get('quantity') || '1', 10);

          if (!variantId && formVariantId) {
            variantId = formVariantId;
          }

          if (Number.isFinite(formQuantityValue) && formQuantityValue > 0) {
            quantityValue = formQuantityValue;
          }

          formData.forEach((value, key) => {
            const propertyMatch = key.match(/^properties\[(.*)\]$/);
            if (propertyMatch && !(propertyMatch[1] in properties)) {
              properties[propertyMatch[1]] = value;
            }
          });
        }

        if (!variantId) {
          return;
        }

        if (quickAddHolder) {
          quickAddHolder.classList.add('is-visible');
        }

        button.classList.add('is-loading');
        button.disabled = true;

        const cartAddEndpoint = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/add.js';

        fetch(cartAddEndpoint, {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: Number.isFinite(quantityValue) && quantityValue > 0 ? quantityValue : 1,
                properties,
              },
            ],
          }),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              throw new Error(response.description || response.message || 'Add to cart failed');
            }

            button.classList.remove('is-loading');
            button.classList.add('is-added');

            document.dispatchEvent(
              new CustomEvent('theme:product:added', {
                bubbles: true,
                detail: {
                  response,
                },
              })
            );

            document.dispatchEvent(new CustomEvent('theme:cart:refresh', {bubbles: true}));

            window.setTimeout(() => {
              button.classList.remove('is-added');
              button.disabled = false;
            }, 1200);
          })
          .catch(() => {
            button.classList.remove('is-loading');
            button.disabled = false;
          });
      }

      render() {
        if (!this.config || !this.cards.length) {
          this.hidden = !window.Shopify || !window.Shopify.designMode;
          return;
        }

        const cartItems = this.getCartItems();
        const cartProductIds = new Set(cartItems.map((item) => item.productId));
        const visibleIds = new Set();

        (this.config.rules || []).forEach((rule) => {
          if (!this.evaluateRule(rule, cartItems)) return;
          (rule.recommendedProducts || []).forEach((productId) => visibleIds.add(String(productId)));
        });

        let visibleCount = 0;

        this.cards.forEach((card) => {
          const productId = String(card.dataset.recommendationProduct || '');
          const alreadyInCart = cartProductIds.has(productId);
          const shouldShow =
            visibleIds.has(productId) &&
            !(this.config.hideInCart && alreadyInCart);

          card.hidden = !shouldShow;

          if (shouldShow) {
            visibleCount += 1;
          }
        });

        if (this.emptyMessage) {
          this.emptyMessage.hidden = visibleCount !== 0;
        }

        this.hidden = visibleCount === 0 && !this.emptyMessage && !(window.Shopify && window.Shopify.designMode);

        if (this.track) {
          requestAnimationFrame(() => {
            const maxIndex = Math.max(this.getVisibleCards().length - 1, 0);
            this.activeIndex = Math.min(this.activeIndex, maxIndex);
            this.buildDots(this.getVisibleCards());
            this.updateCarouselPosition();
            this.bindRecommendationButtons();
            this.startAutoplay();
          });
        }
      }
    }

    customElements.define('cart-product-recommendations', CartProductRecommendations);
  }
  } catch(e) { console.error(e); }
})();

})();
